import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const FIND_GMAIL_MESSAGES_REQUEST = NS + 'FIND_GMAIL_MESSAGES_REQUEST'
export const FIND_GMAIL_MESSAGES_SUCCESS = NS + 'FIND_GMAIL_MESSAGES_SUCCESS'
export const FIND_GMAIL_MESSAGE_ERROR = NS + 'FIND_GMAIL_MESSAGE_ERROR'

export const TOGGLE_GMAIL_MESSAGE = NS + 'TOGGLE_GMAIL_MESSAGE'



// WEBPACK FOOTER //
// ./src/modules/gmail/state/type.js